import React from 'react';
import Image from 'next/image';

import ArrowButton, { ArrowLinkButtonProps } from 'Elements/Button/Arrow';

import Grid, { Col } from 'Components/Grid';

import AvatarTabNavigation, { AvatarTabsProps } from 'Modules/TabNavigation/Avatar';

import WaveSVG from 'Public/graphics/waves/promo-point/solent-story/solent-story-wave.svg';
import WaveTabletSVG from 'Public/graphics/waves/promo-point/solent-story/solent-story-wave-tablet.svg';

import {
    Container,
    Wrapper,
    Heading,
    Text,
    Background,
    DesktopWaveWrapper,
    TabletWaveWrapper
} from './SolentStory.styled';

export interface Props {
    heading: string;
    text: string;
    cta?: ArrowLinkButtonProps;
    tabNavigation: AvatarTabsProps;
}

const SolentStory: React.FC<Props> = ({ heading, text, cta, tabNavigation }) => {
    return (
        <Wrapper>
            <Background>
                <DesktopWaveWrapper>
                    <Image src={WaveSVG} alt="" fill style={{ objectFit: 'cover' }} />
                </DesktopWaveWrapper>
                <TabletWaveWrapper>
                    <Image src={WaveTabletSVG} alt="" fill style={{ objectFit: 'cover' }} />
                </TabletWaveWrapper>
            </Background>
            <Grid>
                <Col m={8} l={4}>
                    <Container>
                        <div>
                            <Heading>{heading}</Heading>
                            <Text>{text}</Text>
                            {cta && <ArrowButton {...cta} />}
                        </div>
                    </Container>
                </Col>
                <Col m={10} l={8}>
                    <AvatarTabNavigation {...tabNavigation} />
                </Col>
            </Grid>
        </Wrapper>
    );
};

export default SolentStory;
